import { ReferenceList } from "../../../../components/referenceList";
import { activeValue } from "../../../../components/collectionTools";
import {
  deleteBatchCategory,
  toggleCategoryActiveStatus,
} from "../../../../api/categories";
import { setCategorySearch } from "../../../../reducers/userConfigSlice";
import {
  categoryCatalogNames,
  categoryProductCount,
} from "./categoryListModel";
const definition = {
  key: "category",
  idKey: "categoryId",
  singular: "categoría",
  plural: "categorías",
  nameLabel: "Categoría",
  searchKey: "categorySearch",
  setSearch: setCategorySearch,
  filterId: "category-catalog",
  filterLabel: "Catálogo",
  filterOptions: (rows) => rows[0]?.catalogOptions || [],
  matchesFilter: (row, value) =>
    row.catalogLinks?.some((catalog) => catalog.catalogId === value),
  selectAllLabel: "Seleccionar todas las categorías de esta página",
  searchText: (row) => row.name || "",
  exportName: "categorias",
  remove: deleteBatchCategory,
  toggle: toggleCategoryActiveStatus,
  columns: [
    {
      key: "catalogs",
      label: "Catálogo",
      sortValue: categoryCatalogNames,
      render: (row) => (
        <span
          className="categoryCatalogNames"
          title={
            row.catalogLinks === null
              ? "Relaciones no disponibles"
              : categoryCatalogNames(row)
          }
        >
          {row.catalogLinks === null
            ? "No disponible"
            : categoryCatalogNames(row)}
        </span>
      ),
    },
    {
      key: "products",
      label: "Productos",
      className: "catalogProductCount",
      sortValue: (row) => categoryProductCount(row) ?? -1,
      render: (row) => (
        <span title="Productos de la categoría, en todos sus catálogos">
          {categoryProductCount(row) ?? "—"}
        </span>
      ),
    },
    {
      key: "order",
      label: "Orden",
      className: "catalogProductCount",
      sortValue: (row) => (Number.isFinite(row.order) ? row.order : -1),
      render: (row) => (Number.isFinite(row.order) ? row.order : "—"),
    },
  ],
  exportColumns: [
    { label: "Categoría", value: (row) => row.name },
    { label: "Descripción", value: (row) => row.description },
    { label: "Catálogos", value: categoryCatalogNames },
    { label: "Productos", value: (row) => categoryProductCount(row) ?? "" },
    { label: "Orden", value: (row) => row.order ?? "" },
    {
      label: "Activa",
      value: (row) => (activeValue(row.isActive) ? "Sí" : "No"),
    },
  ],
};
export const CategoryList = (props) => (
  <ReferenceList {...props} definition={definition} />
);
